import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Muhasebe from "@/pages/Muhasebe";
import Cekler from "@/pages/Cekler";
import Cariler from "@/pages/Cariler";
import CariDetail from "@/pages/CariDetail";
import Hakedis from "@/pages/Hakedis";
import Sozlesmeler from "@/pages/Sozlesmeler";
import Ayarlar from "@/pages/Ayarlar";
import Kurumsal from "@/pages/Kurumsal";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/muhasebe" element={<Muhasebe />} />
              <Route path="/cekler" element={<Cekler />} />
              <Route path="/cariler" element={<Cariler />} />
              <Route path="/cari/:id" element={<CariDetail />} />
              <Route path="/hakedis" element={<Hakedis />} />
              <Route path="/sozlesmeler" element={<Sozlesmeler />} />
              <Route path="/ayarlar" element={<Ayarlar />} />
              <Route path="/kurumsal" element={<Kurumsal />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "hsl(var(--card))",
              color: "hsl(var(--foreground))",
              border: "1px solid hsl(var(--border))",
            },
          }}
        />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
